<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @select="v=>$emit('change',v)"
    placeholder="请选择仓库"
    :clearable="clearable"
    idKey="WarehouseId"
    labelKey="WarehouseName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/warehouse").default,
    };
  },
  methods: {
    getDataFunc(params) {
      params = { ...params, ...this.params };
      // console.log("params", params);
      return new Promise((resolve, reject) => {
        this.api.list({ ...params }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

